// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.2.4
//   protoc               v5.28.2
// source: stcs_commons.entity.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { StcsComp, StcsCompList } from "./stcs_comp.entity";
import { StcsCompAccDataMetaData } from "./stcs_comp_acc_data.entity";
import { StcsCompAccMapping } from "./stcs_comp_acc_mapping.entity";
import { StcsCompActualsResValues } from "./stcs_comp_actuals_res_values.entity";
import { StcsCompFssFlat } from "./stcs_comp_fss_flat.entity";
import { StcsCompKpiCfg } from "./stcs_comp_kpi_cfg.entity";
import { StcsCompKpiResValues } from "./stcs_comp_kpi_res_values.entity";
import { StcsCompPlanCfg, StcsCompPlanCfgList } from "./stcs_comp_plan_cfg.entity";
import { StcsCompPlanResValues } from "./stcs_comp_plan_res_values.entity";
import { DmCompDataOverView, DmOrgFsdPreview } from "./stcs_dm.entity";
import { StcsResCode, stcsResCodeFromJSON, stcsResCodeToJSON } from "./stcs_enums.entity";
import { StcsOrg, StcsOrgList, StcsOrgOnboarding, StcsOrgUserList } from "./stcs_org.entity";
import { StcsOrgFsdFlat } from "./stcs_org_fsd_flat.entity";
import { StcsOrgFsdStruct } from "./stcs_org_fsd_struct.entity";
import { OrgGetFsdTemplateList } from "./stcs_org_fsd_template.entity";
import { StcsWappUser } from "./stcs_user.entity";
import { StcsWappSettings } from "./stcs_wapp_settings.entity";

export const protobufPackage = "stcs_cmw";

export interface GenericPayloadResponse {
  res_message: string;
  res_code: StcsResCode;
  empty?: boolean | undefined;
  wapp_user?: StcsWappUser | undefined;
  stcs_org?: StcsOrg | undefined;
  stcs_org_list?: StcsOrgList | undefined;
  stcs_comp?: StcsComp | undefined;
  stcs_comp_list?: StcsCompList | undefined;
  stcs_comp_fss_flat?: StcsCompFssFlat | undefined;
  stcs_comp_actuals_res_values?: StcsCompActualsResValues | undefined;
  stcs_org_fsd_flat?: StcsOrgFsdFlat | undefined;
  stcs_org_user_list?: StcsOrgUserList | undefined;
  stcs_org_fsd_template_list?: OrgGetFsdTemplateList | undefined;
  stcs_org_fsd_struct?: StcsOrgFsdStruct | undefined;
  stcs_comp_plan_cfg?: StcsCompPlanCfg | undefined;
  stcs_comp_plan_cfg_list?: StcsCompPlanCfgList | undefined;
  stcs_comp_plan_res_values?: StcsCompPlanResValues | undefined;
  stcs_comp_acc_mapping?: StcsCompAccMapping | undefined;
  stcs_wapp_settings?: StcsWappSettings | undefined;
  stcs_comp_kpi_cfg?: StcsCompKpiCfg | undefined;
  stcs_comp_kpi_res_values?: StcsCompKpiResValues | undefined;
}

export interface MultiGenericPayloadResponse {
  res_message: string;
  res_code: StcsResCode;
  res_payload?: MultiGenericPayload | undefined;
}

export interface MultiGenericPayload {
  empty: boolean;
  stcs_org?: StcsOrg | undefined;
  stcs_comp_acc_mapping?: StcsCompAccMapping | undefined;
  stcs_org_fsd_flat?: StcsOrgFsdFlat | undefined;
  stcs_comp_acc_data_meta_data?: StcsCompAccDataMetaData | undefined;
  stcs_comp_fss_flat?: StcsCompFssFlat | undefined;
  stcs_comp_actuals_res_values?: StcsCompActualsResValues | undefined;
  stcs_org_onboarding?: StcsOrgOnboarding | undefined;
  stcs_comp_data_overview?: DmCompDataOverView | undefined;
  stcs_org_fsd_preview?: DmOrgFsdPreview | undefined;
  stcs_comp_plan_cfg?: StcsCompPlanCfg | undefined;
  stcs_comp?: StcsComp | undefined;
  stcs_comp_plan_res_values?: StcsCompPlanResValues | undefined;
  stcs_comp_plan_rf_res_values?: StcsCompPlanResValues | undefined;
  stcs_comp_kpi_cfg?: StcsCompKpiCfg | undefined;
  stcs_comp_kpi_res_values?: StcsCompKpiResValues | undefined;
}

function createBaseGenericPayloadResponse(): GenericPayloadResponse {
  return {
    res_message: "",
    res_code: 0,
    empty: undefined,
    wapp_user: undefined,
    stcs_org: undefined,
    stcs_org_list: undefined,
    stcs_comp: undefined,
    stcs_comp_list: undefined,
    stcs_comp_fss_flat: undefined,
    stcs_comp_actuals_res_values: undefined,
    stcs_org_fsd_flat: undefined,
    stcs_org_user_list: undefined,
    stcs_org_fsd_template_list: undefined,
    stcs_org_fsd_struct: undefined,
    stcs_comp_plan_cfg: undefined,
    stcs_comp_plan_cfg_list: undefined,
    stcs_comp_plan_res_values: undefined,
    stcs_comp_acc_mapping: undefined,
    stcs_wapp_settings: undefined,
    stcs_comp_kpi_cfg: undefined,
    stcs_comp_kpi_res_values: undefined,
  };
}

export const GenericPayloadResponse: MessageFns<GenericPayloadResponse> = {
  encode(message: GenericPayloadResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.res_message !== "") {
      writer.uint32(10).string(message.res_message);
    }
    if (message.res_code !== 0) {
      writer.uint32(16).int32(message.res_code);
    }
    if (message.empty !== undefined) {
      writer.uint32(24).bool(message.empty);
    }
    if (message.wapp_user !== undefined) {
      StcsWappUser.encode(message.wapp_user, writer.uint32(34).fork()).join();
    }
    if (message.stcs_org !== undefined) {
      StcsOrg.encode(message.stcs_org, writer.uint32(42).fork()).join();
    }
    if (message.stcs_org_list !== undefined) {
      StcsOrgList.encode(message.stcs_org_list, writer.uint32(50).fork()).join();
    }
    if (message.stcs_comp !== undefined) {
      StcsComp.encode(message.stcs_comp, writer.uint32(58).fork()).join();
    }
    if (message.stcs_comp_list !== undefined) {
      StcsCompList.encode(message.stcs_comp_list, writer.uint32(66).fork()).join();
    }
    if (message.stcs_comp_fss_flat !== undefined) {
      StcsCompFssFlat.encode(message.stcs_comp_fss_flat, writer.uint32(74).fork()).join();
    }
    if (message.stcs_comp_actuals_res_values !== undefined) {
      StcsCompActualsResValues.encode(message.stcs_comp_actuals_res_values, writer.uint32(82).fork()).join();
    }
    if (message.stcs_org_fsd_flat !== undefined) {
      StcsOrgFsdFlat.encode(message.stcs_org_fsd_flat, writer.uint32(90).fork()).join();
    }
    if (message.stcs_org_user_list !== undefined) {
      StcsOrgUserList.encode(message.stcs_org_user_list, writer.uint32(98).fork()).join();
    }
    if (message.stcs_org_fsd_template_list !== undefined) {
      OrgGetFsdTemplateList.encode(message.stcs_org_fsd_template_list, writer.uint32(106).fork()).join();
    }
    if (message.stcs_org_fsd_struct !== undefined) {
      StcsOrgFsdStruct.encode(message.stcs_org_fsd_struct, writer.uint32(114).fork()).join();
    }
    if (message.stcs_comp_plan_cfg !== undefined) {
      StcsCompPlanCfg.encode(message.stcs_comp_plan_cfg, writer.uint32(122).fork()).join();
    }
    if (message.stcs_comp_plan_cfg_list !== undefined) {
      StcsCompPlanCfgList.encode(message.stcs_comp_plan_cfg_list, writer.uint32(130).fork()).join();
    }
    if (message.stcs_comp_plan_res_values !== undefined) {
      StcsCompPlanResValues.encode(message.stcs_comp_plan_res_values, writer.uint32(138).fork()).join();
    }
    if (message.stcs_comp_acc_mapping !== undefined) {
      StcsCompAccMapping.encode(message.stcs_comp_acc_mapping, writer.uint32(154).fork()).join();
    }
    if (message.stcs_wapp_settings !== undefined) {
      StcsWappSettings.encode(message.stcs_wapp_settings, writer.uint32(162).fork()).join();
    }
    if (message.stcs_comp_kpi_cfg !== undefined) {
      StcsCompKpiCfg.encode(message.stcs_comp_kpi_cfg, writer.uint32(170).fork()).join();
    }
    if (message.stcs_comp_kpi_res_values !== undefined) {
      StcsCompKpiResValues.encode(message.stcs_comp_kpi_res_values, writer.uint32(178).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GenericPayloadResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGenericPayloadResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.res_message = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.res_code = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.empty = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.wapp_user = StcsWappUser.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.stcs_org = StcsOrg.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.stcs_org_list = StcsOrgList.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.stcs_comp = StcsComp.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.stcs_comp_list = StcsCompList.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.stcs_comp_fss_flat = StcsCompFssFlat.decode(reader, reader.uint32());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.stcs_comp_actuals_res_values = StcsCompActualsResValues.decode(reader, reader.uint32());
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.stcs_org_fsd_flat = StcsOrgFsdFlat.decode(reader, reader.uint32());
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.stcs_org_user_list = StcsOrgUserList.decode(reader, reader.uint32());
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.stcs_org_fsd_template_list = OrgGetFsdTemplateList.decode(reader, reader.uint32());
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.stcs_org_fsd_struct = StcsOrgFsdStruct.decode(reader, reader.uint32());
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.stcs_comp_plan_cfg = StcsCompPlanCfg.decode(reader, reader.uint32());
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.stcs_comp_plan_cfg_list = StcsCompPlanCfgList.decode(reader, reader.uint32());
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.stcs_comp_plan_res_values = StcsCompPlanResValues.decode(reader, reader.uint32());
          continue;
        }
        case 19: {
          if (tag !== 154) {
            break;
          }

          message.stcs_comp_acc_mapping = StcsCompAccMapping.decode(reader, reader.uint32());
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.stcs_wapp_settings = StcsWappSettings.decode(reader, reader.uint32());
          continue;
        }
        case 21: {
          if (tag !== 170) {
            break;
          }

          message.stcs_comp_kpi_cfg = StcsCompKpiCfg.decode(reader, reader.uint32());
          continue;
        }
        case 22: {
          if (tag !== 178) {
            break;
          }

          message.stcs_comp_kpi_res_values = StcsCompKpiResValues.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GenericPayloadResponse {
    return {
      res_message: isSet(object.res_message) ? globalThis.String(object.res_message) : "",
      res_code: isSet(object.res_code) ? stcsResCodeFromJSON(object.res_code) : 0,
      empty: isSet(object.empty) ? globalThis.Boolean(object.empty) : undefined,
      wapp_user: isSet(object.wapp_user) ? StcsWappUser.fromJSON(object.wapp_user) : undefined,
      stcs_org: isSet(object.stcs_org) ? StcsOrg.fromJSON(object.stcs_org) : undefined,
      stcs_org_list: isSet(object.stcs_org_list) ? StcsOrgList.fromJSON(object.stcs_org_list) : undefined,
      stcs_comp: isSet(object.stcs_comp) ? StcsComp.fromJSON(object.stcs_comp) : undefined,
      stcs_comp_list: isSet(object.stcs_comp_list) ? StcsCompList.fromJSON(object.stcs_comp_list) : undefined,
      stcs_comp_fss_flat: isSet(object.stcs_comp_fss_flat)
        ? StcsCompFssFlat.fromJSON(object.stcs_comp_fss_flat)
        : undefined,
      stcs_comp_actuals_res_values: isSet(object.stcs_comp_actuals_res_values)
        ? StcsCompActualsResValues.fromJSON(object.stcs_comp_actuals_res_values)
        : undefined,
      stcs_org_fsd_flat: isSet(object.stcs_org_fsd_flat)
        ? StcsOrgFsdFlat.fromJSON(object.stcs_org_fsd_flat)
        : undefined,
      stcs_org_user_list: isSet(object.stcs_org_user_list)
        ? StcsOrgUserList.fromJSON(object.stcs_org_user_list)
        : undefined,
      stcs_org_fsd_template_list: isSet(object.stcs_org_fsd_template_list)
        ? OrgGetFsdTemplateList.fromJSON(object.stcs_org_fsd_template_list)
        : undefined,
      stcs_org_fsd_struct: isSet(object.stcs_org_fsd_struct)
        ? StcsOrgFsdStruct.fromJSON(object.stcs_org_fsd_struct)
        : undefined,
      stcs_comp_plan_cfg: isSet(object.stcs_comp_plan_cfg)
        ? StcsCompPlanCfg.fromJSON(object.stcs_comp_plan_cfg)
        : undefined,
      stcs_comp_plan_cfg_list: isSet(object.stcs_comp_plan_cfg_list)
        ? StcsCompPlanCfgList.fromJSON(object.stcs_comp_plan_cfg_list)
        : undefined,
      stcs_comp_plan_res_values: isSet(object.stcs_comp_plan_res_values)
        ? StcsCompPlanResValues.fromJSON(object.stcs_comp_plan_res_values)
        : undefined,
      stcs_comp_acc_mapping: isSet(object.stcs_comp_acc_mapping)
        ? StcsCompAccMapping.fromJSON(object.stcs_comp_acc_mapping)
        : undefined,
      stcs_wapp_settings: isSet(object.stcs_wapp_settings)
        ? StcsWappSettings.fromJSON(object.stcs_wapp_settings)
        : undefined,
      stcs_comp_kpi_cfg: isSet(object.stcs_comp_kpi_cfg)
        ? StcsCompKpiCfg.fromJSON(object.stcs_comp_kpi_cfg)
        : undefined,
      stcs_comp_kpi_res_values: isSet(object.stcs_comp_kpi_res_values)
        ? StcsCompKpiResValues.fromJSON(object.stcs_comp_kpi_res_values)
        : undefined,
    };
  },

  toJSON(message: GenericPayloadResponse): unknown {
    const obj: any = {};
    if (message.res_message !== "") {
      obj.res_message = message.res_message;
    }
    if (message.res_code !== 0) {
      obj.res_code = stcsResCodeToJSON(message.res_code);
    }
    if (message.empty !== undefined) {
      obj.empty = message.empty;
    }
    if (message.wapp_user !== undefined) {
      obj.wapp_user = StcsWappUser.toJSON(message.wapp_user);
    }
    if (message.stcs_org !== undefined) {
      obj.stcs_org = StcsOrg.toJSON(message.stcs_org);
    }
    if (message.stcs_org_list !== undefined) {
      obj.stcs_org_list = StcsOrgList.toJSON(message.stcs_org_list);
    }
    if (message.stcs_comp !== undefined) {
      obj.stcs_comp = StcsComp.toJSON(message.stcs_comp);
    }
    if (message.stcs_comp_list !== undefined) {
      obj.stcs_comp_list = StcsCompList.toJSON(message.stcs_comp_list);
    }
    if (message.stcs_comp_fss_flat !== undefined) {
      obj.stcs_comp_fss_flat = StcsCompFssFlat.toJSON(message.stcs_comp_fss_flat);
    }
    if (message.stcs_comp_actuals_res_values !== undefined) {
      obj.stcs_comp_actuals_res_values = StcsCompActualsResValues.toJSON(message.stcs_comp_actuals_res_values);
    }
    if (message.stcs_org_fsd_flat !== undefined) {
      obj.stcs_org_fsd_flat = StcsOrgFsdFlat.toJSON(message.stcs_org_fsd_flat);
    }
    if (message.stcs_org_user_list !== undefined) {
      obj.stcs_org_user_list = StcsOrgUserList.toJSON(message.stcs_org_user_list);
    }
    if (message.stcs_org_fsd_template_list !== undefined) {
      obj.stcs_org_fsd_template_list = OrgGetFsdTemplateList.toJSON(message.stcs_org_fsd_template_list);
    }
    if (message.stcs_org_fsd_struct !== undefined) {
      obj.stcs_org_fsd_struct = StcsOrgFsdStruct.toJSON(message.stcs_org_fsd_struct);
    }
    if (message.stcs_comp_plan_cfg !== undefined) {
      obj.stcs_comp_plan_cfg = StcsCompPlanCfg.toJSON(message.stcs_comp_plan_cfg);
    }
    if (message.stcs_comp_plan_cfg_list !== undefined) {
      obj.stcs_comp_plan_cfg_list = StcsCompPlanCfgList.toJSON(message.stcs_comp_plan_cfg_list);
    }
    if (message.stcs_comp_plan_res_values !== undefined) {
      obj.stcs_comp_plan_res_values = StcsCompPlanResValues.toJSON(message.stcs_comp_plan_res_values);
    }
    if (message.stcs_comp_acc_mapping !== undefined) {
      obj.stcs_comp_acc_mapping = StcsCompAccMapping.toJSON(message.stcs_comp_acc_mapping);
    }
    if (message.stcs_wapp_settings !== undefined) {
      obj.stcs_wapp_settings = StcsWappSettings.toJSON(message.stcs_wapp_settings);
    }
    if (message.stcs_comp_kpi_cfg !== undefined) {
      obj.stcs_comp_kpi_cfg = StcsCompKpiCfg.toJSON(message.stcs_comp_kpi_cfg);
    }
    if (message.stcs_comp_kpi_res_values !== undefined) {
      obj.stcs_comp_kpi_res_values = StcsCompKpiResValues.toJSON(message.stcs_comp_kpi_res_values);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GenericPayloadResponse>, I>>(base?: I): GenericPayloadResponse {
    return GenericPayloadResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GenericPayloadResponse>, I>>(object: I): GenericPayloadResponse {
    const message = createBaseGenericPayloadResponse();
    message.res_message = object.res_message ?? "";
    message.res_code = object.res_code ?? 0;
    message.empty = object.empty ?? undefined;
    message.wapp_user = (object.wapp_user !== undefined && object.wapp_user !== null)
      ? StcsWappUser.fromPartial(object.wapp_user)
      : undefined;
    message.stcs_org = (object.stcs_org !== undefined && object.stcs_org !== null)
      ? StcsOrg.fromPartial(object.stcs_org)
      : undefined;
    message.stcs_org_list = (object.stcs_org_list !== undefined && object.stcs_org_list !== null)
      ? StcsOrgList.fromPartial(object.stcs_org_list)
      : undefined;
    message.stcs_comp = (object.stcs_comp !== undefined && object.stcs_comp !== null)
      ? StcsComp.fromPartial(object.stcs_comp)
      : undefined;
    message.stcs_comp_list = (object.stcs_comp_list !== undefined && object.stcs_comp_list !== null)
      ? StcsCompList.fromPartial(object.stcs_comp_list)
      : undefined;
    message.stcs_comp_fss_flat = (object.stcs_comp_fss_flat !== undefined && object.stcs_comp_fss_flat !== null)
      ? StcsCompFssFlat.fromPartial(object.stcs_comp_fss_flat)
      : undefined;
    message.stcs_comp_actuals_res_values =
      (object.stcs_comp_actuals_res_values !== undefined && object.stcs_comp_actuals_res_values !== null)
        ? StcsCompActualsResValues.fromPartial(object.stcs_comp_actuals_res_values)
        : undefined;
    message.stcs_org_fsd_flat = (object.stcs_org_fsd_flat !== undefined && object.stcs_org_fsd_flat !== null)
      ? StcsOrgFsdFlat.fromPartial(object.stcs_org_fsd_flat)
      : undefined;
    message.stcs_org_user_list = (object.stcs_org_user_list !== undefined && object.stcs_org_user_list !== null)
      ? StcsOrgUserList.fromPartial(object.stcs_org_user_list)
      : undefined;
    message.stcs_org_fsd_template_list =
      (object.stcs_org_fsd_template_list !== undefined && object.stcs_org_fsd_template_list !== null)
        ? OrgGetFsdTemplateList.fromPartial(object.stcs_org_fsd_template_list)
        : undefined;
    message.stcs_org_fsd_struct = (object.stcs_org_fsd_struct !== undefined && object.stcs_org_fsd_struct !== null)
      ? StcsOrgFsdStruct.fromPartial(object.stcs_org_fsd_struct)
      : undefined;
    message.stcs_comp_plan_cfg = (object.stcs_comp_plan_cfg !== undefined && object.stcs_comp_plan_cfg !== null)
      ? StcsCompPlanCfg.fromPartial(object.stcs_comp_plan_cfg)
      : undefined;
    message.stcs_comp_plan_cfg_list =
      (object.stcs_comp_plan_cfg_list !== undefined && object.stcs_comp_plan_cfg_list !== null)
        ? StcsCompPlanCfgList.fromPartial(object.stcs_comp_plan_cfg_list)
        : undefined;
    message.stcs_comp_plan_res_values =
      (object.stcs_comp_plan_res_values !== undefined && object.stcs_comp_plan_res_values !== null)
        ? StcsCompPlanResValues.fromPartial(object.stcs_comp_plan_res_values)
        : undefined;
    message.stcs_comp_acc_mapping =
      (object.stcs_comp_acc_mapping !== undefined && object.stcs_comp_acc_mapping !== null)
        ? StcsCompAccMapping.fromPartial(object.stcs_comp_acc_mapping)
        : undefined;
    message.stcs_wapp_settings = (object.stcs_wapp_settings !== undefined && object.stcs_wapp_settings !== null)
      ? StcsWappSettings.fromPartial(object.stcs_wapp_settings)
      : undefined;
    message.stcs_comp_kpi_cfg = (object.stcs_comp_kpi_cfg !== undefined && object.stcs_comp_kpi_cfg !== null)
      ? StcsCompKpiCfg.fromPartial(object.stcs_comp_kpi_cfg)
      : undefined;
    message.stcs_comp_kpi_res_values =
      (object.stcs_comp_kpi_res_values !== undefined && object.stcs_comp_kpi_res_values !== null)
        ? StcsCompKpiResValues.fromPartial(object.stcs_comp_kpi_res_values)
        : undefined;
    return message;
  },
};

function createBaseMultiGenericPayloadResponse(): MultiGenericPayloadResponse {
  return { res_message: "", res_code: 0, res_payload: undefined };
}

export const MultiGenericPayloadResponse: MessageFns<MultiGenericPayloadResponse> = {
  encode(message: MultiGenericPayloadResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.res_message !== "") {
      writer.uint32(10).string(message.res_message);
    }
    if (message.res_code !== 0) {
      writer.uint32(16).int32(message.res_code);
    }
    if (message.res_payload !== undefined) {
      MultiGenericPayload.encode(message.res_payload, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MultiGenericPayloadResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMultiGenericPayloadResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.res_message = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.res_code = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.res_payload = MultiGenericPayload.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MultiGenericPayloadResponse {
    return {
      res_message: isSet(object.res_message) ? globalThis.String(object.res_message) : "",
      res_code: isSet(object.res_code) ? stcsResCodeFromJSON(object.res_code) : 0,
      res_payload: isSet(object.res_payload) ? MultiGenericPayload.fromJSON(object.res_payload) : undefined,
    };
  },

  toJSON(message: MultiGenericPayloadResponse): unknown {
    const obj: any = {};
    if (message.res_message !== "") {
      obj.res_message = message.res_message;
    }
    if (message.res_code !== 0) {
      obj.res_code = stcsResCodeToJSON(message.res_code);
    }
    if (message.res_payload !== undefined) {
      obj.res_payload = MultiGenericPayload.toJSON(message.res_payload);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MultiGenericPayloadResponse>, I>>(base?: I): MultiGenericPayloadResponse {
    return MultiGenericPayloadResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MultiGenericPayloadResponse>, I>>(object: I): MultiGenericPayloadResponse {
    const message = createBaseMultiGenericPayloadResponse();
    message.res_message = object.res_message ?? "";
    message.res_code = object.res_code ?? 0;
    message.res_payload = (object.res_payload !== undefined && object.res_payload !== null)
      ? MultiGenericPayload.fromPartial(object.res_payload)
      : undefined;
    return message;
  },
};

function createBaseMultiGenericPayload(): MultiGenericPayload {
  return {
    empty: false,
    stcs_org: undefined,
    stcs_comp_acc_mapping: undefined,
    stcs_org_fsd_flat: undefined,
    stcs_comp_acc_data_meta_data: undefined,
    stcs_comp_fss_flat: undefined,
    stcs_comp_actuals_res_values: undefined,
    stcs_org_onboarding: undefined,
    stcs_comp_data_overview: undefined,
    stcs_org_fsd_preview: undefined,
    stcs_comp_plan_cfg: undefined,
    stcs_comp: undefined,
    stcs_comp_plan_res_values: undefined,
    stcs_comp_plan_rf_res_values: undefined,
    stcs_comp_kpi_cfg: undefined,
    stcs_comp_kpi_res_values: undefined,
  };
}

export const MultiGenericPayload: MessageFns<MultiGenericPayload> = {
  encode(message: MultiGenericPayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.empty !== false) {
      writer.uint32(8).bool(message.empty);
    }
    if (message.stcs_org !== undefined) {
      StcsOrg.encode(message.stcs_org, writer.uint32(18).fork()).join();
    }
    if (message.stcs_comp_acc_mapping !== undefined) {
      StcsCompAccMapping.encode(message.stcs_comp_acc_mapping, writer.uint32(26).fork()).join();
    }
    if (message.stcs_org_fsd_flat !== undefined) {
      StcsOrgFsdFlat.encode(message.stcs_org_fsd_flat, writer.uint32(34).fork()).join();
    }
    if (message.stcs_comp_acc_data_meta_data !== undefined) {
      StcsCompAccDataMetaData.encode(message.stcs_comp_acc_data_meta_data, writer.uint32(42).fork()).join();
    }
    if (message.stcs_comp_fss_flat !== undefined) {
      StcsCompFssFlat.encode(message.stcs_comp_fss_flat, writer.uint32(50).fork()).join();
    }
    if (message.stcs_comp_actuals_res_values !== undefined) {
      StcsCompActualsResValues.encode(message.stcs_comp_actuals_res_values, writer.uint32(58).fork()).join();
    }
    if (message.stcs_org_onboarding !== undefined) {
      StcsOrgOnboarding.encode(message.stcs_org_onboarding, writer.uint32(66).fork()).join();
    }
    if (message.stcs_comp_data_overview !== undefined) {
      DmCompDataOverView.encode(message.stcs_comp_data_overview, writer.uint32(74).fork()).join();
    }
    if (message.stcs_org_fsd_preview !== undefined) {
      DmOrgFsdPreview.encode(message.stcs_org_fsd_preview, writer.uint32(82).fork()).join();
    }
    if (message.stcs_comp_plan_cfg !== undefined) {
      StcsCompPlanCfg.encode(message.stcs_comp_plan_cfg, writer.uint32(122).fork()).join();
    }
    if (message.stcs_comp !== undefined) {
      StcsComp.encode(message.stcs_comp, writer.uint32(130).fork()).join();
    }
    if (message.stcs_comp_plan_res_values !== undefined) {
      StcsCompPlanResValues.encode(message.stcs_comp_plan_res_values, writer.uint32(138).fork()).join();
    }
    if (message.stcs_comp_plan_rf_res_values !== undefined) {
      StcsCompPlanResValues.encode(message.stcs_comp_plan_rf_res_values, writer.uint32(146).fork()).join();
    }
    if (message.stcs_comp_kpi_cfg !== undefined) {
      StcsCompKpiCfg.encode(message.stcs_comp_kpi_cfg, writer.uint32(154).fork()).join();
    }
    if (message.stcs_comp_kpi_res_values !== undefined) {
      StcsCompKpiResValues.encode(message.stcs_comp_kpi_res_values, writer.uint32(162).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MultiGenericPayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMultiGenericPayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.empty = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.stcs_org = StcsOrg.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.stcs_comp_acc_mapping = StcsCompAccMapping.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.stcs_org_fsd_flat = StcsOrgFsdFlat.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.stcs_comp_acc_data_meta_data = StcsCompAccDataMetaData.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.stcs_comp_fss_flat = StcsCompFssFlat.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.stcs_comp_actuals_res_values = StcsCompActualsResValues.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.stcs_org_onboarding = StcsOrgOnboarding.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.stcs_comp_data_overview = DmCompDataOverView.decode(reader, reader.uint32());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.stcs_org_fsd_preview = DmOrgFsdPreview.decode(reader, reader.uint32());
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.stcs_comp_plan_cfg = StcsCompPlanCfg.decode(reader, reader.uint32());
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.stcs_comp = StcsComp.decode(reader, reader.uint32());
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.stcs_comp_plan_res_values = StcsCompPlanResValues.decode(reader, reader.uint32());
          continue;
        }
        case 18: {
          if (tag !== 146) {
            break;
          }

          message.stcs_comp_plan_rf_res_values = StcsCompPlanResValues.decode(reader, reader.uint32());
          continue;
        }
        case 19: {
          if (tag !== 154) {
            break;
          }

          message.stcs_comp_kpi_cfg = StcsCompKpiCfg.decode(reader, reader.uint32());
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.stcs_comp_kpi_res_values = StcsCompKpiResValues.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MultiGenericPayload {
    return {
      empty: isSet(object.empty) ? globalThis.Boolean(object.empty) : false,
      stcs_org: isSet(object.stcs_org) ? StcsOrg.fromJSON(object.stcs_org) : undefined,
      stcs_comp_acc_mapping: isSet(object.stcs_comp_acc_mapping)
        ? StcsCompAccMapping.fromJSON(object.stcs_comp_acc_mapping)
        : undefined,
      stcs_org_fsd_flat: isSet(object.stcs_org_fsd_flat)
        ? StcsOrgFsdFlat.fromJSON(object.stcs_org_fsd_flat)
        : undefined,
      stcs_comp_acc_data_meta_data: isSet(object.stcs_comp_acc_data_meta_data)
        ? StcsCompAccDataMetaData.fromJSON(object.stcs_comp_acc_data_meta_data)
        : undefined,
      stcs_comp_fss_flat: isSet(object.stcs_comp_fss_flat)
        ? StcsCompFssFlat.fromJSON(object.stcs_comp_fss_flat)
        : undefined,
      stcs_comp_actuals_res_values: isSet(object.stcs_comp_actuals_res_values)
        ? StcsCompActualsResValues.fromJSON(object.stcs_comp_actuals_res_values)
        : undefined,
      stcs_org_onboarding: isSet(object.stcs_org_onboarding)
        ? StcsOrgOnboarding.fromJSON(object.stcs_org_onboarding)
        : undefined,
      stcs_comp_data_overview: isSet(object.stcs_comp_data_overview)
        ? DmCompDataOverView.fromJSON(object.stcs_comp_data_overview)
        : undefined,
      stcs_org_fsd_preview: isSet(object.stcs_org_fsd_preview)
        ? DmOrgFsdPreview.fromJSON(object.stcs_org_fsd_preview)
        : undefined,
      stcs_comp_plan_cfg: isSet(object.stcs_comp_plan_cfg)
        ? StcsCompPlanCfg.fromJSON(object.stcs_comp_plan_cfg)
        : undefined,
      stcs_comp: isSet(object.stcs_comp) ? StcsComp.fromJSON(object.stcs_comp) : undefined,
      stcs_comp_plan_res_values: isSet(object.stcs_comp_plan_res_values)
        ? StcsCompPlanResValues.fromJSON(object.stcs_comp_plan_res_values)
        : undefined,
      stcs_comp_plan_rf_res_values: isSet(object.stcs_comp_plan_rf_res_values)
        ? StcsCompPlanResValues.fromJSON(object.stcs_comp_plan_rf_res_values)
        : undefined,
      stcs_comp_kpi_cfg: isSet(object.stcs_comp_kpi_cfg)
        ? StcsCompKpiCfg.fromJSON(object.stcs_comp_kpi_cfg)
        : undefined,
      stcs_comp_kpi_res_values: isSet(object.stcs_comp_kpi_res_values)
        ? StcsCompKpiResValues.fromJSON(object.stcs_comp_kpi_res_values)
        : undefined,
    };
  },

  toJSON(message: MultiGenericPayload): unknown {
    const obj: any = {};
    if (message.empty !== false) {
      obj.empty = message.empty;
    }
    if (message.stcs_org !== undefined) {
      obj.stcs_org = StcsOrg.toJSON(message.stcs_org);
    }
    if (message.stcs_comp_acc_mapping !== undefined) {
      obj.stcs_comp_acc_mapping = StcsCompAccMapping.toJSON(message.stcs_comp_acc_mapping);
    }
    if (message.stcs_org_fsd_flat !== undefined) {
      obj.stcs_org_fsd_flat = StcsOrgFsdFlat.toJSON(message.stcs_org_fsd_flat);
    }
    if (message.stcs_comp_acc_data_meta_data !== undefined) {
      obj.stcs_comp_acc_data_meta_data = StcsCompAccDataMetaData.toJSON(message.stcs_comp_acc_data_meta_data);
    }
    if (message.stcs_comp_fss_flat !== undefined) {
      obj.stcs_comp_fss_flat = StcsCompFssFlat.toJSON(message.stcs_comp_fss_flat);
    }
    if (message.stcs_comp_actuals_res_values !== undefined) {
      obj.stcs_comp_actuals_res_values = StcsCompActualsResValues.toJSON(message.stcs_comp_actuals_res_values);
    }
    if (message.stcs_org_onboarding !== undefined) {
      obj.stcs_org_onboarding = StcsOrgOnboarding.toJSON(message.stcs_org_onboarding);
    }
    if (message.stcs_comp_data_overview !== undefined) {
      obj.stcs_comp_data_overview = DmCompDataOverView.toJSON(message.stcs_comp_data_overview);
    }
    if (message.stcs_org_fsd_preview !== undefined) {
      obj.stcs_org_fsd_preview = DmOrgFsdPreview.toJSON(message.stcs_org_fsd_preview);
    }
    if (message.stcs_comp_plan_cfg !== undefined) {
      obj.stcs_comp_plan_cfg = StcsCompPlanCfg.toJSON(message.stcs_comp_plan_cfg);
    }
    if (message.stcs_comp !== undefined) {
      obj.stcs_comp = StcsComp.toJSON(message.stcs_comp);
    }
    if (message.stcs_comp_plan_res_values !== undefined) {
      obj.stcs_comp_plan_res_values = StcsCompPlanResValues.toJSON(message.stcs_comp_plan_res_values);
    }
    if (message.stcs_comp_plan_rf_res_values !== undefined) {
      obj.stcs_comp_plan_rf_res_values = StcsCompPlanResValues.toJSON(message.stcs_comp_plan_rf_res_values);
    }
    if (message.stcs_comp_kpi_cfg !== undefined) {
      obj.stcs_comp_kpi_cfg = StcsCompKpiCfg.toJSON(message.stcs_comp_kpi_cfg);
    }
    if (message.stcs_comp_kpi_res_values !== undefined) {
      obj.stcs_comp_kpi_res_values = StcsCompKpiResValues.toJSON(message.stcs_comp_kpi_res_values);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MultiGenericPayload>, I>>(base?: I): MultiGenericPayload {
    return MultiGenericPayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MultiGenericPayload>, I>>(object: I): MultiGenericPayload {
    const message = createBaseMultiGenericPayload();
    message.empty = object.empty ?? false;
    message.stcs_org = (object.stcs_org !== undefined && object.stcs_org !== null)
      ? StcsOrg.fromPartial(object.stcs_org)
      : undefined;
    message.stcs_comp_acc_mapping =
      (object.stcs_comp_acc_mapping !== undefined && object.stcs_comp_acc_mapping !== null)
        ? StcsCompAccMapping.fromPartial(object.stcs_comp_acc_mapping)
        : undefined;
    message.stcs_org_fsd_flat = (object.stcs_org_fsd_flat !== undefined && object.stcs_org_fsd_flat !== null)
      ? StcsOrgFsdFlat.fromPartial(object.stcs_org_fsd_flat)
      : undefined;
    message.stcs_comp_acc_data_meta_data =
      (object.stcs_comp_acc_data_meta_data !== undefined && object.stcs_comp_acc_data_meta_data !== null)
        ? StcsCompAccDataMetaData.fromPartial(object.stcs_comp_acc_data_meta_data)
        : undefined;
    message.stcs_comp_fss_flat = (object.stcs_comp_fss_flat !== undefined && object.stcs_comp_fss_flat !== null)
      ? StcsCompFssFlat.fromPartial(object.stcs_comp_fss_flat)
      : undefined;
    message.stcs_comp_actuals_res_values =
      (object.stcs_comp_actuals_res_values !== undefined && object.stcs_comp_actuals_res_values !== null)
        ? StcsCompActualsResValues.fromPartial(object.stcs_comp_actuals_res_values)
        : undefined;
    message.stcs_org_onboarding = (object.stcs_org_onboarding !== undefined && object.stcs_org_onboarding !== null)
      ? StcsOrgOnboarding.fromPartial(object.stcs_org_onboarding)
      : undefined;
    message.stcs_comp_data_overview =
      (object.stcs_comp_data_overview !== undefined && object.stcs_comp_data_overview !== null)
        ? DmCompDataOverView.fromPartial(object.stcs_comp_data_overview)
        : undefined;
    message.stcs_org_fsd_preview = (object.stcs_org_fsd_preview !== undefined && object.stcs_org_fsd_preview !== null)
      ? DmOrgFsdPreview.fromPartial(object.stcs_org_fsd_preview)
      : undefined;
    message.stcs_comp_plan_cfg = (object.stcs_comp_plan_cfg !== undefined && object.stcs_comp_plan_cfg !== null)
      ? StcsCompPlanCfg.fromPartial(object.stcs_comp_plan_cfg)
      : undefined;
    message.stcs_comp = (object.stcs_comp !== undefined && object.stcs_comp !== null)
      ? StcsComp.fromPartial(object.stcs_comp)
      : undefined;
    message.stcs_comp_plan_res_values =
      (object.stcs_comp_plan_res_values !== undefined && object.stcs_comp_plan_res_values !== null)
        ? StcsCompPlanResValues.fromPartial(object.stcs_comp_plan_res_values)
        : undefined;
    message.stcs_comp_plan_rf_res_values =
      (object.stcs_comp_plan_rf_res_values !== undefined && object.stcs_comp_plan_rf_res_values !== null)
        ? StcsCompPlanResValues.fromPartial(object.stcs_comp_plan_rf_res_values)
        : undefined;
    message.stcs_comp_kpi_cfg = (object.stcs_comp_kpi_cfg !== undefined && object.stcs_comp_kpi_cfg !== null)
      ? StcsCompKpiCfg.fromPartial(object.stcs_comp_kpi_cfg)
      : undefined;
    message.stcs_comp_kpi_res_values =
      (object.stcs_comp_kpi_res_values !== undefined && object.stcs_comp_kpi_res_values !== null)
        ? StcsCompKpiResValues.fromPartial(object.stcs_comp_kpi_res_values)
        : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
